/*
 * CarImagesConstants
 */

export const UPLOAD_REQUEST = 'ideal/CarImages/UPLOAD_REQUEST';
export const UPLOAD_SUCCESS = 'ideal/CarImages/UPLOAD_SUCCESS';
export const UPLOAD_PROGRESS = 'ideal/CarImages/UPLOAD_PROGRESS';
export const UPLOAD_FAILURE = 'ideal/CarImages/UPLOAD_FAILURE';
export const DOWNLOAD_CAR_IMAGES_REQUEST = 'ideal/CarImages/DOWNLOAD_CAR_IMAGES_REQUEST';
export const DOWNLOAD_CAR_IMAGES_SUCCESS = 'ideal/CarImages/DOWNLOAD_CAR_IMAGES_SUCCESS';
export const SET_MAIN = 'ideal/CarImages/SET_MAIN';
export const SET_MAIN_SUCCESS = 'ideal/CarImages/SET_MAIN_SUCCESS';
export const DELETE = 'ideal/CarImages/DELETE';
export const DELETE_ALL = 'ideal/CarImages/DELETE_ALL';
export const DELETE_SUCCESS = 'ideal/CarImages/DELETE_SUCCESS';
export const DELETE_ALL_SUCCESS = 'ideal/CarImages/DELETE_ALL_SUCCESS';
